export class ReliabilityReportCreateModel {
  public Pn?: string;
  public Sn?: string;
  public Chapter?: number;
  public ReportType?: number;
  public ReportStatus?: number;
  public RefNo?: string;
}

export class ReliabilityReportUpdateModel {
  public Id?: number;
  public GoodsRcvdBatch?: number;
  public ReliabilityReportId?: number;
  public Pn?: string;
  public Sn?: string;
  public Chapter?: number;
  public ReportType?: number;
  public ReportStatus?: number;
  public TargetDate?: Date;
}
